module.exports = __webpack_public_path__ + "static/services-group-b2e8bd771a70d8a84b62fe7d57030670.svg";